import store from '../../store';

export default [
  {
    name: 'Messages',
    path: '/messages',
    components: {
      default: () => import('../../views/Messages.vue')
    },
    meta: {
      requiresAuth: true,
      access_control: ['ROLE_ADMIN', 'ROLE_USER'],
      icon: 'fas fa-comment',
      type: 'link',
      isInMenu: true,
      title: 'main-menu.chat.title',
      order: 5,
    }
  },
  {
    name: 'MessagesWith',
    path: '/messages/:id',
    components: {
      default: () => import('../../views/Chat.vue')
    },
    props: {
      default: true
    },
    meta: {
      requiresAuth: true,
      access_control: ['ROLE_ADMIN', 'ROLE_USER'],
    },
    beforeEnter: (to, from, next) => {
      const id = to.params.id;
      if (!store.getters['corpochat/getChatById'](id)) {
        return next({ name: 'Messages' });
      }
      return next();
    }
  }
];
